module.exports = __webpack_public_path__ + "media/images/icons/more-3aa10f6c9878ba65342d5926b715aef9.svg";